import { useQuery } from '@tanstack/react-query';
import { getClientOptions } from '@/services/client.service';
import { ClientOptions } from '@/types/client';

export const CLIENT_OPTIONS_QUERY_KEY = ['clients', 'options'] as const;

export const useClientOptions = () => {
  const { data, isLoading, error, refetch } = useQuery<ClientOptions>({
    queryKey: CLIENT_OPTIONS_QUERY_KEY,
    queryFn: getClientOptions,
    staleTime: 5 * 60 * 1000,
  });

  return {
    connectedClients: data?.connectedClients ?? [],
    connectionStatuses: data?.connectionStatuses ?? [],
    groups: data?.groups ?? [],
    isLoading,
    error,
    refetch,
  };
};
